import Barcode from "react-barcode";
import "./barcode.scss";
import PageBarCodeStyle from "./pageBarCodeStyle";
const BarCodePost = ({ print = {}, isBig = false }) => {
  return (
    <>
      <PageBarCodeStyle isLarge={isBig} />
      <div className={`holder-print-barcode ${isBig ? "large" : "small"}`}>
        <div className="header">
          <div className="kit-barcode">
            <span>شماره کیت:</span>
            <div className="holder-img">
              {print?.kit && <Barcode displayValue={false} margin={0} font="IRANSansX" value={print?.kit || ""} />}
              <br />
              <span>{print?.kit}</span>
            </div>
          </div>
          <div className="post-barcode">
            <span>بارکدپستی:</span>
            <div className="holder-img">
              {print?.barcode && <Barcode displayValue={false} margin={0} font="IRANSansX" value={print?.barcode?.toString() || ""} />}
              <br />
              <span>{print?.barcode}</span>
            </div>
          </div>
        </div>
        <div className="body-post">
          <table width={"100%"}>
            <tbody>
              <tr>
                <td>
                  <div className="label">استان:</div>
                </td>
                <td>
                  <div className="value">{print?.province}</div>
                </td>
                <td>
                  <div className="label">شهر:</div>
                </td>
                <td>
                  <div className="value">{print?.city}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="label">نام:</div>
                </td>
                <td>
                  <div className="value">{print?.fname}</div>
                </td>
                <td>
                  <div className="label">نام خانوادگی:</div>
                </td>
                <td>
                  <div className="value">{print?.lname}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="label">کدملی:</div>
                </td>
                <td>
                  <div className="value">{print?.certNo}</div>
                </td>
                <td>
                  <div className="label">کدپستی:</div>
                </td>
                <td>
                  <div className="value">{print?.postalcode}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="label">شماره تلفن همراه:</div>
                </td>
                <td>
                  <div className="value">{print?.msisdn}</div>
                </td>
                <td>
                  <div className="label">پلاک:</div>
                </td>
                <td>
                  <div className="value">{print?.unit}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="holder-address">
          <span>
            {print?.mainstreet} , {print?.auxiliaryroad} , {print?.alley} , {print?.block} , {print?.buildingNo} , {print?.unit} , {print?.floor}
          </span>
        </div>
        <div className="holder-footer-box">
          <p>
            لطفا پس از مشاهده <strong>اصل کارت ملی</strong> و احزار هویت مطابق مشخصات مندرج، سیم کارت تحویل مشتری و{" "}
            <strong>یک برگ از سند با اخذامضاء و اثر انگشت مالک، </strong>دریافت و توسط پاکت قبول به صندوق اختصاصی ذکر شده بر روی پاکت عودت داده شود.
          </p>
        </div>
      </div>
    </>
  );
};

export default BarCodePost;
